import "i18next";
import { useTranslation } from "react-i18next";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Checkbox,
  Chip,
  CircularProgress,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import { blue, green, grey } from "@mui/material/colors";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import EmployeeSearch, {
  employeeSearchResultinitialState,
} from "components/Common/EmployeeSearch/EmployeeSearch";
import TextLabel from "components/Common/TextLabel/TextLabel";
import PrimeReactDataGrid from "components/PrimeReactDataGrid/PrimeReactDataGrid";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createIdmOrderRequest,
  getAssociatedReqIds,
  getClientProgram,
  getIdmRitmDetail,
  getIDMUserDetails,
  getInfoClientDetails,
  getnewClientProgram,
  getSiteLocation,
  getTechDepType,
  getTraineeDetailsForIDMTicketByRosterId,
  insertFacilitiesTicket,
  insertIdmEmailQueue,
  insertIdmTicket,
  insertFacilityTicket,
  SaveAttachmentFacilities,
  SaveAttachmentRitm,
  SaveAttachmentRitmForCapClient,
  SaveAttachmentRitmForClient,
  SaveRitmComment,
  insertIdmCredential,
} from "services/userServices";
import { SnackBarStoreAction } from "Store/SnackBar";
import SnackBar from "components/SnackBar/SnackBar";
import { useLocation } from "react-router-dom";
import BackdropComponent from "components/Spinner/Spinner";
import moment from "moment";
import CircleIcon from "@mui/icons-material/Circle";
import { Check, CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { areArraysEqual } from "components/Common/utilities";

const timeZones = [
  "(US/Mountain)",
  "Canada/Atlantic",
  "Canada/Central",
  "Africa/Accra",
  "Canada/Eastern",
  "Canada/Mountain",
  "Canada/Pacific",
  "Europe/Amsterdam",
  "Europe/Berlin",
  "Europe/Brussels",
  "Europe/Copenhagen",
  "Europe/Dublin",
  "Europe/London",
  "Europe/Madrid",
  "Europe/Paris",
  "Europe/Rome",
  "Europe/Stockholm",
  "Europe/Zurich",
  "GMT",
  "Hongkong",
  "US/Arizona",
  "US/Central",
  "US/Eastern",
  "US/Hawaii",
  "US/Mountain",
  "US/Pacific",
  "Asia/Kolkata",
  "America/Buenos_Aires",
  "America/Costa_Rica",
  "Asia/Manila",
  "Australia/Sydney",
  "Brazil/East",
  "Brazil/West",
  "Mexico/General",
  "Pacific/Auckland",
];

const CheckStyle = {
  fontSize: 28,
  color: blue[600],
};

const typesOfRequests = [
  "Activation (New Hire or Reactivation)",
  "Change Role",
];

const paddingRight = { pr: 2.5 };

const formatDateForReadOnly = (date) =>
  moment(date ? new Date(date) : new Date("yyyy-MM-ddTHH:mm")).format(
    "MMMM D, YYYY",
  );

const getCurrentDateTime = () =>
  moment(new Date()).format("YYYY-MM-DDTHH:mm:ss");

const initialSelectedTechDeptType = { AskNowTDTId: 1, AskNowTDT: "unknown" };
const initialSelectedNewClientProgram = {
  ProjectName: "",
  SysId: "",
  ClientCode: "",
  ProgramCode: "",
  ProjectCode: "",
};

const initialSiteOptionState = {
  GeoLocGLCdId: 0,
  GeoLocCd: "",
  LocationTypeCd: "",
  LocationName: "",
  LocationDesc: "",
  Geo_or_GL: "",
  GLLocCd: "",
  SysId: "",
  CreatedDate: "",
  CreatedBy: "",
  ModifiedDate: "",
  ModifiedBy: "",
  IsActive: true,
};

const initialCurrentClientProgramOptionState = [
  {
    name: "",
    sysid: "",
    install_status: "",
    u_client_code: "",
    support_group: "",
  },
];

const prepareRequestedForDateTimePayloadObject = (dataValue) => {
  let requestedForDateTime = new Date(dataValue);
  let date = moment(new Date(requestedForDateTime)).format("YYYY-MM-DD");

  let hours = requestedForDateTime.getHours();
  let minutes = requestedForDateTime.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  const strTime = hours + ":" + minutes + " " + ampm;
  return {
    date: date,
    time: strTime,
  };
};

export default function GenerateIdmTicket() {
  const location = useLocation();
  const navigate = useNavigate();
  const [taleoReqIdOptions, settaleoReqIdOptions] = useState([]);
  const [classRosterId, setClassRosterId] = useState(
    location?.state?.classRosterId,
  );
  const [classRequestId, setClassRequestId] = useState(
    location?.state?.classRequestId,
  );
  const [selectedTaleoId, setSelectedTaleoId] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime());
  const [requestForDateTime, setRequestForDateTime] = useState(currentDateTime);
  const [requestForDateTimeForPayload, setRequestForDateTimeForPayload] =
    useState(prepareRequestedForDateTimePayloadObject(currentDateTime));
  const [tteTrainingDate, setTteTrainingDate] = useState(null);
  const [isNoEquipmentNeeded, setisNoEquipmentNeeded] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableFirst, setTableFirst] = useState(0);
  const [tableRows, setTableRows] = useState(25); 
  const [loading, setLoading] = useState(false);
  const [traineeDetailRows, setTraineeDetailRows] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslation(["IdmRequest"]);
  const asknowStore = useSelector((state) => state.askNow);
  const [ttfTrainerData, setTtfTrainerData] = useState(
    location?.state?.ttfTrainerData,
  );
  const [askNowTdt, setAskNowTdt] = useState(location?.state?.askNowTDT);
  const [siteOptions, setSiteOptions] = useState([]);
  const [newClientProgramOptions, setNewClientProgramOptions] = useState([]);
  const [currentClientProgramOptions, setCurrentClientProgramOptions] =
    useState([]);
  const [clientPrograms, setClientPrograms] = useState([]);
  const [techDeptTypeOptions, setTechDeptTypeOptions] = useState([]);
  const [traineeDetailsResponse, setTraineeDetailsResponse] = useState();
  const [waveNumber, setWaveNumber] = useState();

  const [tciTtdStartDate, setTciTtdStartDate] = useState();
  const [productionTrainingStart, setProductionTrainingStart] = useState();
  const [productionDate, setProductionDate] = useState();
  const [requestForDetails, setRequestForDetails] = useState(
    employeeSearchResultinitialState,
  );
  const [requestForSysId, setRequestForSysId] = useState();
  const [waveTrainerDetails, setWaveTrainerDetails] = useState(
    employeeSearchResultinitialState,
  );
  const [waveTrainerSysId, setWaveTrainerSysId] = useState("");
  const [managerDetails, setManagerDetails] = useState(
    employeeSearchResultinitialState,
  );
  const [managerSysId, setManagerSysId] = useState("");
  const [requestForOracleId, setRequestForOracleId] = useState("");
  const [waveTrainerOracleId, setWaveTrainerOracleId] = useState("");
  const [currentClientProgramSysId, setCurrentClientProgramSysId] = useState();
  const [managerForOracleId, setManagerOracleId] = useState();
  const [clientCode, setClientCode] = useState();
  const [clientName, setClientName] = useState();
  const [selectedTechDeploymentType, setSelectedTechDeploymentType] = useState(
    initialSelectedTechDeptType,
  );
  const [selectedTypeOfRequest, setSelectedTypeOfRequest] = useState(
    typesOfRequests[0],
  );
  const [selectedSite, setSelectedSite] = useState(initialSiteOptionState);
  const [selectedNewClientProgram, setSelectedNewClientProgram] = useState(
    initialSelectedNewClientProgram,
  );
  const [currentTraineeProjectCodes, setCurrentTraineeProjectCodes] = useState(
    [],
  );
  const [selectedCurrentClientProgram, setSelectedCurrentClientProgram] =
    useState(initialCurrentClientProgramOptionState);
  const [selectedRequestedForTimezone, setSelectedRequestedForTimezone] =
    useState(null);
  const [stateErrorFlags, setStateErrorFlags] = useState({
    taleoId: false,
    requestForDateTime: false,
    newClientProgram: false,
    waveTrainer: false,
    requestedFor: false,
    tteTrainingDate: false,
    site: false,
    manager: false,
    requestedForTimezone: false,
    currentClientProgram: false,
  });

  const [createTicketLoading, setCreateTicketLoading] = useState(false);
  const [createTicketShowHeader, setCreateTicketShowHeader] = useState(false);
  const [createTicketSuccess, setCreateTicketSuccess] = useState(false);

  const [createIdmRecordLoading, setCreateIdmRecordLoading] = useState(false);
  const [createIdmRecordShowHeader, setCreateIdmRecordShowHeader] =
    useState(false);
  const [createIdmRecordSuccess, setCreateIdmRecordSuccess] = useState(false);
  const [idmCredentialTrackingId, setIdmCredentialTrackingId] = useState(0);

  const [getRitmTicketLoading, setGetRitmTicketLoading] = useState(false);
  const [getRitmTicketShowHeader, setGetRitmTicketShowHeader] = useState(false);
  const [getRitmTicketSuccess, setGetRitmTicketSuccess] = useState(false);

  const [uploadOnboardingTemplateLoading, setUploadOnboardingTemplateLoading] =
    useState(false);
  const [
    uploadOnboardingTemplateShowHeader,
    setUploadOnboardingTemplateShowHeader,
  ] = useState(false);
  const [uploadOnboardingTemplateSuccess, setUploadOnboardingTemplateSuccess] =
    useState(false);

  const [facilitiesTicketLoading, setFacilitiesTicketLoading] = useState(false);
  const [facilitiesTicketShowHeader, setFacilitiesTicketShowHeader] =
    useState(false);
  const [facilitiesTicketSuccess, setFacilitiesTicketSuccess] = useState(false);
  const [uploadFacilitiesTemplateShowHeader, setUploadFacilitiesShowHeader] =
    useState(false);
  const [uploadFacilitiesTemplateLoading, setUploadFacilitiesTemplateLoading] =
    useState(false);
  const [uploadFacilitiesTemplateSuccess, setUploadFacilitiesTemplateSuccess] =
    useState(false);

  const [emailNotificationLoading, setEmailNotificationLoading] =
    useState(false);
  const [emailNotificationShowHeader, setEmailNotificationShowHeader] =
    useState(false);
  const [emailNotificationSuccess, setEmailNotificationSuccess] =
    useState(false);

  const [idmResponseDialogOpen, setIdmResponseDialogOpen] = useState(false);

  const [reqNumber, setReqNumber] = useState("");
  const [ritmNumber, setRitmNumber] = useState("");
  const [facilitiesTicketNumber, setFacilitiesTicketNumber] = useState("");
  const [clearFieldsCount, setClearFieldsCount] = useState(0);
  const [onLoadCallsStatus, setOnLoadCallsStatus] = useState({
    traineeDetails: 0,
    taleoReqIds: 0,
    sites: 0,
    clientDetails: 0,
    newClientProgramDetails: 0,
    clientProgramDetails: 0,
    techDeptTypes: 0,
    idmUserDetails: 0,
  });
  const areAllOnLoadCallsCompleted = () => {
    return Object.values(onLoadCallsStatus).every((status) => status === 1);
  };

  const showSnack = (message, severity) => {
    const obj = {
      open: true,
      message: message,
      severity: severity,
    };
    dispatch(SnackBarStoreAction.updateSnack(obj));
  };
  const [reloadTrainees, setReloadTrainees] = useState(0);

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const toggleErrorFlags = (key, value) => {
    if (value === true || (value === false && stateErrorFlags[key] === true)) {
      setStateErrorFlags({ ...stateErrorFlags, [key]: value });
    }
  };

  // A trainee's AD account is enabled, but Saviynt returned a null/missing
  // extensionAttribute9, so we can't tell if this is a reactivation or a new
  // hire. Per ASTT-7267, don't guess — let the requester choose the correct
  // ticket type and flag it for review.
  const isAdInfoIncomplete = (rowData) => rowData?.isAdInfoIncomplete === true;

  const ActiveInAdBodyTemplate = (rowData) => {
    const needsReview = isAdInfoIncomplete(rowData);
    const adStatus = needsReview
      ? "Need Review"
      : rowData.activeInAD
        ? "Active"
        : "Inactive";
    const isAdStatusActive = adStatus === "Active";
    const chipColor = needsReview
      ? "#ED6C02"
      : isAdStatusActive
        ? green[500]
        : grey[500];
    const chipIcon = needsReview ? (
      <CircleIcon fontSize="small" color={chipColor} />
    ) : isAdStatusActive ? (
      <CheckCircle fontSize="small" color={chipColor} />
    ) : (
      <CircleIcon fontSize="small" color={chipColor} />
    );
    return (
      <Chip
        icon={chipIcon}
        label={adStatus}
        size="small"
        variant="outlined"
        title={
          needsReview
            ? "Active Directory information is incomplete, please review and choose New Hire or Change Role as needed."
            : undefined
        }
        sx={{
          fontWeight: 600,
          letterSpacing: "0.05em",
          color: chipColor,
          borderColor: chipColor,
          p: 0.5,
        }}
      />
    );
  };

  const resetAllStates = () => {
    settaleoReqIdOptions([]);
    setClassRosterId(location?.state?.classRosterId);
    setClassRequestId(location?.state?.classRequestId);
    setSelectedTaleoId(null);
    setCurrentDateTime(getCurrentDateTime());
    setRequestForDateTime(getCurrentDateTime());
    setRequestForDateTimeForPayload(
      prepareRequestedForDateTimePayloadObject(getCurrentDateTime()),
    );
    setTteTrainingDate(null);
    setisNoEquipmentNeeded(false);
    setSelectedRows([]);
    setLoading(false);
    setTraineeDetailRows([]);
    setTtfTrainerData(location?.state?.ttfTrainerData);
    setAskNowTdt(location?.state?.askNowTDT);
    setSiteOptions([]);
    setNewClientProgramOptions([]);
    setCurrentClientProgramOptions([]);
    setClientPrograms([]);
    setTechDeptTypeOptions([]);
    setTraineeDetailsResponse(undefined);
    setWaveNumber(undefined);
    setTciTtdStartDate(undefined);
    setProductionTrainingStart(undefined);
    setProductionDate(undefined);
    setRequestForDetails(employeeSearchResultinitialState);
    setRequestForSysId(undefined);
    setWaveTrainerDetails(employeeSearchResultinitialState);
    setWaveTrainerSysId("");
    setManagerDetails(employeeSearchResultinitialState);
    setManagerSysId("");
    setRequestForOracleId("");
    setWaveTrainerOracleId("");
    setCurrentClientProgramSysId(undefined);
    setManagerOracleId(undefined);
    setClientCode(undefined);
    setClientName(undefined);
    setSelectedTechDeploymentType(initialSelectedTechDeptType);
    setSelectedTypeOfRequest(typesOfRequests[0]);
    setSelectedSite(initialSiteOptionState);
    setSelectedNewClientProgram(initialSelectedNewClientProgram);
    setCurrentTraineeProjectCodes([]);
    setSelectedCurrentClientProgram(initialCurrentClientProgramOptionState);
    setSelectedRequestedForTimezone(null);
    setStateErrorFlags({
      taleoId: false,
      requestForDateTime: false,
      newClientProgram: false,
      waveTrainer: false,
      requestedFor: false,
      tteTrainingDate: false,
      site: false,
      manager: false,
      requestedForTimezone: false,
      currentClientProgram: false,
    });
    setCreateTicketLoading(false);
    setCreateTicketShowHeader(false);
    setCreateTicketSuccess(false);
    setGetRitmTicketLoading(false);
    setGetRitmTicketShowHeader(false);
    setGetRitmTicketSuccess(false);
    setUploadOnboardingTemplateLoading(false);
    setUploadOnboardingTemplateShowHeader(false);
    setUploadOnboardingTemplateSuccess(false);
    setFacilitiesTicketLoading(false);
    setFacilitiesTicketShowHeader(false);
    setFacilitiesTicketSuccess(false);
    setEmailNotificationLoading(false);
    setEmailNotificationShowHeader(false);
    setEmailNotificationSuccess(false);
    setIdmResponseDialogOpen(false);
    setReqNumber("");
    setRitmNumber("");
    setFacilitiesTicketNumber("");
    setCreateIdmRecordLoading(false);
    setCreateIdmRecordShowHeader(false);
    setCreateIdmRecordSuccess(false);
    setIdmCredentialTrackingId(0);
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const columns = [
    {
      selectionMode: "multiple",
      frozen: true,
      align: "right",
      bodyStyle: {
        justifyContent: "center",
      },
    },
    {
      field: "oracleId",
      header: "Oracle ID",
      sortable: true,
      filter: true,
      align: "left",
      bodyStyle: {
        textAlign: "left",
      },
    },
    {
      field: "preferredFirstName",
      header: "First Name",
      sortable: true,
      filter: true,
      align: "left",
      bodyStyle: {
        textAlign: "left",
      },
    },
    {
      field: "preferredLastName",
      header: "Last Name",
      sortable: true,
      filter: true,
      align: "left",
      bodyStyle: {
        textAlign: "left",
      },
    },
    {
      field: "dateAdded",
      header: "Date Assigned",
      sortable: true,
      filter: true,
      align: "left",
      bodyStyle: {
        textAlign: "left",
      },
    },
    {
      field: "activeInAD",
      header: "Active in AD",
      sortable: true,
      filter: true,
      align: "left",
      bodyStyle: {
        textAlign: "left",
      },
      body: ActiveInAdBodyTemplate,
    },
    {
      field: "idmTicketNumber",
      header: "RITM#",
      sortable: true,
      filter: true,
      align: "left",
      bodyStyle: {
        textAlign: "left",
      },
    },
    {
      field: "cppClientCode",
      header: "CPP Client Code",
      sortable: true,
      filter: true,
      align: "left",
      bodyStyle: {
        textAlign: "left",
      },
    },
    {
      field: "cppProjectCode",
      header: "CPP Program Code",
      sortable: true,
      filter: true,
      align: "left",
      bodyStyle: {
        textAlign: "left",
      },
      headerStyle: {
        textAlign: "left",
      },
    },
  ];

  const filterProps = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
    oracleId: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    preferredFirstName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    preferredLastName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    dateAdded: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    activeInAD: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    idmTicketNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    cppClientCode: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    cppProgramCode: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
  };

  const filter = createFilterOptions();

  const handleTaleoReqIdChange = (event, value) => {
    if (typeof value === "string") {
      setSelectedTaleoId({
        title: value.toUpperCase(),
      });
    } else if (value?.inputValue) {
      setSelectedTaleoId({
        title: value.inputValue.toUpperCase(),
      });
    } else {
      setSelectedTaleoId(value);
    }

    toggleErrorFlags("taleoId", false);
  };

  const handleRequestedForDateTime = (event) => {
    if (event.target.value === "") {
      setRequestForDateTime(null);
    } else {
      setRequestForDateTime(event.target.value);
      setRequestForDateTimeForPayload(
        prepareRequestedForDateTimePayloadObject(event.target.value),
      );

      toggleErrorFlags("requestForDateTime", false);
    }
  };

  const handleTteTrainingDateDateChange = (event) => {
    setTteTrainingDate(event.target.value);
    if (event.target.value !== "") {
      toggleErrorFlags("tteTrainingDate", false);
    }
  };

  const onRowSelectChange = (event) => {
    setSelectedRows(event.value);
  };

  const fetchAndSetUpTraineeDetails = async (classRosterId) => {
    setLoading(true);
    const traineeDetails =
      await getTraineeDetailsForIDMTicketByRosterId(classRosterId);
    setOnLoadCallsStatus((prevState) => ({ ...prevState, traineeDetails: 1 }));
    setLoading(false);
    if (traineeDetails.statusCode === 200) {
      setTraineeDetailsResponse(traineeDetails);
      const traineeData = traineeDetails.data["traineeDetails"].map(
        (trainee, index) => ({
          ...trainee,
          uniqueId: `${trainee.oracleId}-${index}`,
        }),
      );

      setTraineeDetailRows(traineeData);

      setWaveNumber(traineeDetails.data["rosterDetail"]["wave"]);

      setRequestForDateTime(traineeDetails.data["rosterDetail"]["reqDateTime"]);
      setTciTtdStartDate(
        ttfTrainerData[0] !== null
          ? ttfTrainerData[0]
          : ttfTrainerData[1] !== null
            ? ttfTrainerData[1]
            : ttfTrainerData[2],
      );

      setProductionTrainingStart(
        traineeDetails.data["rosterDetail"]["productTrainingDate"] !== null
          ? traineeDetails.data["rosterDetail"]["productTrainingDate"]
          : ttfTrainerData[4],
      );

      setProductionDate(
        traineeDetails.data["rosterDetail"]["productionDate"] !== null
          ? traineeDetails.data["rosterDetail"]["productionDate"]
          : ttfTrainerData[3],
      );
    } else {
      setLoading(false);
      showSnack("Failed to load trainees", "error");
    }
  };

  const setUpStateForTrainerOrManager = (data, type) => {
    if (type === "requestedFor") {
      setRequestForSysId(data?.sysid);

      toggleErrorFlags("requestedFor", false);
    }
    if (type === "waveTrainer") {
      setWaveTrainerSysId(data?.sysid);
      if (data?.hasOwnProperty("user_name")) {
        setWaveTrainerDetails({
          ...employeeSearchResultinitialState,
          Name: data?.name?.toLowerCase(),
          Email: data?.email,
          OracleId: data?.oracleId,
          Display: data?.name + " (" + data?.email + ")",
        });
      } else {
        setWaveTrainerDetails(data);
      }

      toggleErrorFlags("waveTrainer", false);
    }
    if (type === "manager") {
      setManagerSysId(data?.sysid);
    }
  };

  const setUpStatesForOracleId = (OracleId, type) => {
    if (type === "requestedFor") setRequestForOracleId(OracleId);
    if (type === "waveTrainer") setWaveTrainerOracleId(OracleId);
    if (type === "manager") setManagerOracleId(OracleId);
  };

  const fetchIDMuserDetails = async (OracleId, type) => {
    if (OracleId != "" || OracleId !== undefined || OracleId !== null) {
      setUpStatesForOracleId(OracleId, type);
      setLoading(true);
      const userDetails = await getIDMUserDetails(OracleId);

      setOnLoadCallsStatus((prevState) => ({
        ...prevState,
        idmUserDetails: 1,
      }));
      setLoading(false);
      if (userDetails.status === true) {
        let objuserDetails = JSON.parse(userDetails["data"]);
        if (objuserDetails.result.length > 0) {
          setUpStateForTrainerOrManager(objuserDetails.result[0], type);
        }
      } else {
        setSnack({
          open: true,
          message: "Failed to load User asknow Details",
          severity: "error",
        });
      }
    }
  };

  const setUpTechDeploymentType = (value, options) => {
    return options?.find((option) => option?.AskNowTDT === value);
  };
  // Helper function to prepare trainer object
  const prepareTrainerObject = (ttfTrainerData, traineeDetailsResponse) => {
    const rosterDetail = traineeDetailsResponse?.data["rosterDetail"];

    return {
      Email: ttfTrainerData[7] || rosterDetail["email"],
      Name: ttfTrainerData[6] || rosterDetail["requestFor"],
      OracleId: ttfTrainerData[5] || rosterDetail["trainerId"],
    };
  };

  // Helper function to fetch and set Taleo Req IDs
  const fetchTaleoReqIds = async (
    classRosterId,
    setLoading,
    setOnLoadCallsStatus,
    settaleoReqIdOptions,
    setSnack,
  ) => {
    setLoading(true);
    const taleoReqList = await getAssociatedReqIds(classRosterId);
    setOnLoadCallsStatus((prevState) => ({ ...prevState, taleoReqIds: 1 }));
    setLoading(false);

    if (taleoReqList.status === true) {
      settaleoReqIdOptions(taleoReqList.data);
    } else {
      setSnack({
        open: true,
        message: "There are no Associated Taleo Requisition Ids'",
        severity: "info",
      });
    }
  };

  // Helper function to fetch and set Site Location
  const fetchSiteLocation = async (
    classRequestId,
    setLoading,
    setOnLoadCallsStatus,
    setSiteOptions,
    setSnack,
  ) => {
    setLoading(true);
    const siteLocation = await getSiteLocation(classRequestId);
    setOnLoadCallsStatus((prevState) => ({ ...prevState, sites: 1 }));
    setLoading(false);

    if (siteLocation.status === true) {
      setSiteOptions(siteLocation.data);
    } else {
      setSnack({
        open: true,
        message: "Failed to get Site/Location details",
        severity: "error",
      });
    }
  };

  // Helper function to fetch Informatica Client Details
  const fetchInformaticaClientDetails = async (
    classRequestId,
    setLoading,
    setOnLoadCallsStatus,
    setSnack,
  ) => {
    setLoading(true);
    const informaticaClientDetails = await getInfoClientDetails(classRequestId);
    setOnLoadCallsStatus((prevState) => ({ ...prevState, clientDetails: 1 }));
    setLoading(false);

    if (informaticaClientDetails.status !== true) {
      setSnack({
        open: true,
        message: "Failed to load Client Details",
        severity: "error",
      });
      return null;
    }

    return informaticaClientDetails;
  };

  // Helper function to fetch and set New Client Program
  const fetchNewClientProgram = async (
    classRequestId,
    setLoading,
    setOnLoadCallsStatus,
    setNewClientProgramOptions,
    setSnack,
  ) => {
    setLoading(true);
    const newClientProgram = await getnewClientProgram(classRequestId);
    setOnLoadCallsStatus((prevState) => ({
      ...prevState,
      newClientProgramDetails: 1,
    }));
    setLoading(false);

    if (newClientProgram.status === true) {
      setNewClientProgramOptions(newClientProgram.data);
    } else {
      setSnack({
        open: true,
        message: "No Associated project to get New/Client Program details",
        severity: "info",
      });
    }
  };

  // Helper function to set current client program details
  const setCurrentClientProgramDetails = (
    currentClientPrograms,
    informaticaClientDetails,
    setCurrentClientProgramSysId,
    setClientCode,
    setClientName,
  ) => {
    if (informaticaClientDetails?.data?.length > 0) {
      const filteredData = currentClientPrograms.filter(
        (itm) =>
          itm.u_client_code === informaticaClientDetails.data[0].u_client_code,
      );

      if (filteredData.length > 0) {
        setCurrentClientProgramSysId(filteredData[0].sysid);
        setClientCode(filteredData[0].u_client_code);
        setClientName(filteredData[0].name);
      }
    }
  };

  // Helper function to fetch and set Current Client Program
  const fetchCurrentClientProgram = async (
    setLoading,
    setOnLoadCallsStatus,
    setClientPrograms,
    informaticaClientDetails,
    setCurrentClientProgramSysId,
    setClientCode,
    setClientName,
    setSnack,
  ) => {
    setLoading(true);
    const currentClientProgram = await getClientProgram();
    setOnLoadCallsStatus((prevState) => ({
      ...prevState,
      clientProgramDetails: 1,
    }));
    setLoading(false);

    if (currentClientProgram.status === true) {
      const objCurrentClientProgram = JSON.parse(currentClientProgram["data"]);
      setClientPrograms(objCurrentClientProgram.result);

      setCurrentClientProgramDetails(
        objCurrentClientProgram.result,
        informaticaClientDetails,
        setCurrentClientProgramSysId,
        setClientCode,
        setClientName,
      );
    } else {
      setSnack({
        open: true,
        message: "Failed to load current client Details",
        severity: "error",
      });
    }
  };

  // Helper function to fetch and set Tech Deployment Type
  const fetchTechDeploymentType = async (
    askNowTdt,
    setUpTechDeploymentType,
    setLoading,
    setOnLoadCallsStatus,
    setTechDeptTypeOptions,
    setSelectedTechDeploymentType,
    setSnack,
  ) => {
    setLoading(true);
    const technologyDepType = await getTechDepType();
    setOnLoadCallsStatus((prevState) => ({ ...prevState, techDeptTypes: 1 }));
    setLoading(false);

    if (technologyDepType.status === true) {
      setTechDeptTypeOptions(technologyDepType.data);
      setSelectedTechDeploymentType(
        setUpTechDeploymentType(askNowTdt || "unknown", technologyDepType.data),
      );
    } else {
      setSnack({
        open: true,
        message: "Failed to load Tech Deployment type Details",
        severity: "error",
      });
    }
  };

  // Refactored main function
  const fetchAndSetUpDetails = async () => {
    if (traineeDetailsResponse?.statusCode !== 200) {
      return;
    }

    setTteTrainingDate(
      traineeDetailsResponse?.data["rosterDetail"]["tteTrainingDate"],
    );

    const trainerObj = prepareTrainerObject(
      ttfTrainerData,
      traineeDetailsResponse,
    );

    await fetchTaleoReqIds(
      classRosterId,
      setLoading,
      setOnLoadCallsStatus,
      settaleoReqIdOptions,
      setSnack,
    );

    await fetchSiteLocation(
      classRequestId,
      setLoading,
      setOnLoadCallsStatus,
      setSiteOptions,
      setSnack,
    );

    const informaticaClientDetails = await fetchInformaticaClientDetails(
      classRequestId,
      setLoading,
      setOnLoadCallsStatus,
      setSnack,
    );

    await fetchNewClientProgram(
      classRequestId,
      setLoading,
      setOnLoadCallsStatus,
      setNewClientProgramOptions,
      setSnack,
    );

    await fetchCurrentClientProgram(
      setLoading,
      setOnLoadCallsStatus,
      setClientPrograms,
      informaticaClientDetails,
      setCurrentClientProgramSysId,
      setClientCode,
      setClientName,
      setSnack,
    );

    await fetchTechDeploymentType(
      askNowTdt,
      setUpTechDeploymentType,
      setLoading,
      setOnLoadCallsStatus,
      setTechDeptTypeOptions,
      setSelectedTechDeploymentType,
      setSnack,
    );

    fetchIDMuserDetails(trainerObj.OracleId, "waveTrainer");
    setLoading(false);
  };

  useEffect(() => {
    let cancelled = false;

    const loadTraineeDetails = async () => {
      if (classRosterId || reloadTrainees > 0) {
        try {
          await fetchAndSetUpTraineeDetails(classRosterId);
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to fetch trainee details:", error);
          }
        }
      }
    };

    loadTraineeDetails();

    return () => {
      cancelled = true;
    };
  }, [classRosterId, reloadTrainees]);

  useEffect(() => {
    let cancelled = false;

    const setupDetails = async () => {
      if (traineeDetailsResponse) {
        try {
          await fetchAndSetUpDetails();
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to setup details:", error);
          }
        }
      }
    };

    setupDetails();

    return () => {
      cancelled = true;
    };
  }, [traineeDetailsResponse]);

  useEffect(() => {
    setCurrentTraineeProjectCodes(
      traineeDetailRows.map((row) => row?.cppProjectCode),
    );
  }, [traineeDetailRows]);

  const filterByProjectCodes = () => {
    const filteredCCP = clientPrograms?.filter((item) => {
      const splitArr = item.u_client_code.split(".");
      if (splitArr.length < 4) return false;
      const projectCode = splitArr[3];
      return currentTraineeProjectCodes?.includes(projectCode);
    });
    setCurrentClientProgramOptions(filteredCCP);
  };

  useEffect(() => {
    if (currentTraineeProjectCodes?.length > 0 && clientPrograms?.length > 0)
      filterByProjectCodes();
  }, [clientPrograms, currentTraineeProjectCodes]);

  useEffect(() => {
    if (idmResponseDialogOpen === false && areAllOnLoadCallsCompleted()) {
      setOnLoadCallsStatus({
        traineeDetails: 0,
        taleoReqIds: 0,
        sites: 0,
        clientDetails: 0,
        newClientProgramDetails: 0,
        clientProgramDetails: 0,
        techDeptTypes: 0,
        idmUserDetails: 0,
      });
      resetAllStates();
      setReloadTrainees(reloadTrainees + 1);
      setClearFieldsCount(clearFieldsCount + 1);
    }
  }, [idmResponseDialogOpen]);

  const getCurrentClientSysIds = () =>
    selectedCurrentClientProgram?.length > 0
      ? selectedCurrentClientProgram?.map((item) => item?.sysid)
      : [];

  const preparePayloadForIdmTicket = () => {
    return {
      sysparm_quantity: 1,
      variables: {
        cmdb_ci: "dad2e7294ffa1280f15e3285f110c7ff",
        caller_id: requestForSysId,
        idm_requested_date:
          requestForDateTimeForPayload.date +
          " " +
          requestForDateTimeForPayload.time,
        idm_access_type:
          selectedTypeOfRequest === "Activation (New Hire or Reactivation)"
            ? "Activation"
            : selectedTypeOfRequest,
        idm_multiple_porgram: "yes",
        idm_emp_type: "agent",
        idm_wave_number: waveNumber,
        idm_request_number: selectedTaleoId?.title,
        tci_ttd_start_date: tciTtdStartDate,
        idm_tte_training_date: tteTrainingDate,
        product_training_start_date: productionTrainingStart,
        idm_production_date: productionDate,
        idm_site: selectedSite?.SysId,
        idm_new_cp: selectedNewClientProgram?.SysId,
        technology_Deployment_Type: selectedTechDeploymentType.AskNowTDT,
        idm_wave_trainer: waveTrainerSysId,
        idm_ops_manager: managerSysId,
        idm_product_training_date: tteTrainingDate,
        requested_for_time: selectedRequestedForTimezone,
        system_account_provisioning_only: isNoEquipmentNeeded,
        idm_mul_cp2:
          selectedTypeOfRequest === "Change Role"
            ? getCurrentClientSysIds()
            : [selectedNewClientProgram?.SysId],
      },
    };
  };

  const areCurrentClientProgramsValid = () => {
    let isValid = true;
    selectedCurrentClientProgram.forEach((item) => {
      if (
        item?.sysid === "" ||
        item?.sysid === undefined ||
        item?.sysid === null
      ) {
        isValid = false;
      }
    });
    return isValid;
  };

  // Helper function to validate field is not empty
  const isFieldEmpty = (value) => {
    return value === null || value === undefined || value === "";
  };

  // Helper function to validate sys ID
  const isSysIdInvalid = (sysId) => {
    return isFieldEmpty(sysId);
  };

  // Helper function to validate display field
  const isDisplayInvalid = (displayValue) => {
    return isFieldEmpty(displayValue);
  };

  // Validation helper for Taleo ID
  const validateTaleoId = (selectedTaleoId, toggleErrorFlags, showSnack) => {
    if (selectedTaleoId === null) {
      toggleErrorFlags("taleoId", true);
      showSnack("Please select Taleo Req ID", "warning");
      return false;
    }
    return true;
  };

  // Validation helper for Request For DateTime
  const validateRequestForDateTime = (
    requestForDateTime,
    toggleErrorFlags,
    showSnack,
  ) => {
    if (isFieldEmpty(requestForDateTime)) {
      toggleErrorFlags("requestForDateTime", true);
      showSnack("Please select Requested For Date time", "warning");
      return false;
    }
    return true;
  };

  // Validation helper for New Client Program
  const validateNewClientProgram = (
    selectedNewClientProgram,
    toggleErrorFlags,
    showSnack,
  ) => {
    if (selectedNewClientProgram.ProjectName === "") {
      toggleErrorFlags("newClientProgram", true);
      showSnack("Please select a New Client Program", "warning");
      return false;
    }

    if (isSysIdInvalid(selectedNewClientProgram.SysId)) {
      toggleErrorFlags("newClientProgram", true);
      showSnack("Please select a valid New Client Program", "warning");
      return false;
    }

    return true;
  };

  // Validation helper for Wave Trainer
  const validateWaveTrainer = (
    waveTrainerDetails,
    waveTrainerSysId,
    toggleErrorFlags,
    showSnack,
  ) => {
    if (isDisplayInvalid(waveTrainerDetails.Display)) {
      toggleErrorFlags("waveTrainer", true);
      showSnack("Please select a Wave Trainer", "warning");
      return false;
    }

    if (waveTrainerSysId === "") {
      toggleErrorFlags("waveTrainer", true);
      showSnack("Please select a valid Wave Trainer", "warning");
      return false;
    }

    return true;
  };

  // Validation helper for Request For
  const validateRequestFor = (
    requestForDetails,
    requestForSysId,
    toggleErrorFlags,
    showSnack,
  ) => {
    if (isDisplayInvalid(requestForDetails.Display)) {
      toggleErrorFlags("requestFor", true);
      showSnack("Please select a Requested for", "warning");
      return false;
    }

    if (requestForSysId === "") {
      toggleErrorFlags("requestFor", true);
      showSnack("Please select a valid Requested for", "warning");
      return false;
    }

    return true;
  };

  // Validation helper for Site/Location
  const validateSite = (selectedSite, toggleErrorFlags, showSnack) => {
    if (selectedSite.LocationName === "") {
      toggleErrorFlags("site", true);
      showSnack("Please select a Site/Location", "warning");
      return false;
    }

    if (isSysIdInvalid(selectedSite.SysId)) {
      toggleErrorFlags("site", true);
      showSnack("Please select a valid Site/Location", "warning");
      return false;
    }

    return true;
  };

  // Validation helper for Manager
  const validateManager = (
    managerDetails,
    managerSysId,
    toggleErrorFlags,
    showSnack,
  ) => {
    if (isDisplayInvalid(managerDetails.Display)) {
      toggleErrorFlags("manager", true);
      showSnack("Please select a Manager", "warning");
      return false;
    }

    if (managerSysId === "") {
      toggleErrorFlags("manager", true);
      showSnack("Please select a valid Manager", "warning");
      return false;
    }

    return true;
  };

  // Validation helper for Change Role specific fields
  const validateChangeRoleFields = (
    selectedTypeOfRequest,
    selectedRequestedForTimezone,
    selectedCurrentClientProgram,
    initialCurrentClientProgramOptionState,
    areArraysEqual,
    areCurrentClientProgramsValid,
    toggleErrorFlags,
    showSnack,
  ) => {
    if (selectedTypeOfRequest !== "Change Role") {
      return true;
    }

    if (isFieldEmpty(selectedRequestedForTimezone)) {
      toggleErrorFlags("requestedForTimezone", true);
      showSnack("Please select a Requested For Timezone", "warning");
      return false;
    }

    if (
      areArraysEqual(
        selectedCurrentClientProgram,
        initialCurrentClientProgramOptionState,
      )
    ) {
      toggleErrorFlags("currentClientProgram", true);
      showSnack("Please select a Current Client Program", "warning");
      return false;
    }

    if (!areCurrentClientProgramsValid()) {
      toggleErrorFlags("currentClientProgram", true);
      showSnack("Please select a valid Current Client Program", "warning");
      return false;
    }

    return true;
  };

  // Validation helper for selected rows
  const validateSelectedRows = (selectedRows, showSnack) => {
    if (selectedRows.length === 0) {
      showSnack("Please select at least one Trainee", "warning");
      return false;
    }
    return true;
  };

  // Refactored main function
  const validateInputs = () => {
    if (!validateTaleoId(selectedTaleoId, toggleErrorFlags, showSnack)) {
      return false;
    }

    if (
      !validateRequestForDateTime(
        requestForDateTime,
        toggleErrorFlags,
        showSnack,
      )
    ) {
      return false;
    }

    if (
      !validateNewClientProgram(
        selectedNewClientProgram,
        toggleErrorFlags,
        showSnack,
      )
    ) {
      return false;
    }

    if (
      !validateWaveTrainer(
        waveTrainerDetails,
        waveTrainerSysId,
        toggleErrorFlags,
        showSnack,
      )
    ) {
      return false;
    }

    if (
      !validateRequestFor(
        requestForDetails,
        requestForSysId,
        toggleErrorFlags,
        showSnack,
      )
    ) {
      return false;
    }

    if (!validateSite(selectedSite, toggleErrorFlags, showSnack)) {
      return false;
    }

    if (
      !validateManager(
        managerDetails,
        managerSysId,
        toggleErrorFlags,
        showSnack,
      )
    ) {
      return false;
    }

    if (
      !validateChangeRoleFields(
        selectedTypeOfRequest,
        selectedRequestedForTimezone,
        selectedCurrentClientProgram,
        initialCurrentClientProgramOptionState,
        areArraysEqual,
        areCurrentClientProgramsValid,
        toggleErrorFlags,
        showSnack,
      )
    ) {
      return false;
    }

    if (!validateSelectedRows(selectedRows, showSnack)) {
      return false;
    }

    return true;
  };

  const getAndSetTicketSysId = (createIdmTicketResponse) => {
    const ticketData = JSON.parse(createIdmTicketResponse["data"]);
    setReqNumber(ticketData["result"].number);
    return ticketData["result"].sys_id;
  };

  const isIdmCreationLoadersActive = () =>
    createTicketLoading ||
    getRitmTicketLoading ||
    uploadOnboardingTemplateLoading ||
    facilitiesTicketLoading ||
    emailNotificationLoading ||
    createIdmRecordLoading;

  const handleGenerateIdmTicket = async () => {
    if (validateInputs()) {
      const payload = preparePayloadForIdmTicket();

      setIdmResponseDialogOpen(true);
      setCreateTicketShowHeader(true);
      setCreateTicketLoading(true);

      const createIdmTicketResponse = await createIdmOrderRequest(payload);
      setCreateTicketLoading(false);
      if (createIdmTicketResponse?.status === true) {
        setCreateTicketSuccess(true);
        const ticketSysId = getAndSetTicketSysId(createIdmTicketResponse);
        RITMPostCreationProcess(ticketSysId);
      } else {
        setCreateTicketSuccess(false);
        showSnack("Unable to generate IDM ticket", "error");
      }
    }
  };

  const prepareIdmInsertPayload = (ritmNumber) => ({
    classRosterId: classRosterId,
    siteCode: "",
    clientCode: "",
    projectCodes: "",
    headCount: 0,
    technologyDeploymentTypeId: 0,
    rosterLockDate: moment(),
    trainingStartDate: moment(),
    ticketType:
      selectedTypeOfRequest === "Activation (New Hire or Reactivation)"
        ? "Activation"
        : selectedTypeOfRequest,
    openedByTaHc: true,
    emailDate: null,
    nonAutomatedQmsDate: null,
    askNowRITM: ritmNumber,
    ntLoginIsuDate: null,
    switchType: null,
    ttecSwitchIdDate: null,
    clientIDSubmissionDate: null,
    clientIDCompletionDate: null,
    clientSwitchSubmissionDate: null,
    clientSwitchCompletionDate: null,
    clientAccessCalDate: null,
    dateCheckedByTl: null,
    systemImpacted: [{ systemImpactedId: null }],
    issueDescription: [{ issueDescriptionId: null }],
    sanityCheckNotes: [{ sanityCheckNotesId: null }],
    impacted: 0,
    notes: "",
    createdBy: "Spflow Admin",
  });

  const prepareTraineeDetails = () => {
    const isChangeRoleRequest = selectedTypeOfRequest === "Change Role";
    return selectedRows?.map((row) => ({
      oracleId: row.oracleId,
      firstName: row.preferredFirstName,
      lastName: row.preferredLastName,
      cppClientCode: isChangeRoleRequest
        ? selectedNewClientProgram.ClientCode
        : row.cppClientCode,
      cppProgramCode: isChangeRoleRequest
        ? selectedNewClientProgram.ProgramCode
        : row.cppProgramCode,
      cppProjectCode: isChangeRoleRequest
        ? selectedNewClientProgram.ProjectCode
        : row.cppProjectCode,
      jobTitle: row.jobTitle,
      projectName: selectedNewClientProgram.ProjectName,
      department: row.department,
      locationId: row.locationId,
      tdt: selectedTechDeploymentType.AskNowTDT,
      productTrainingStartDate: tteTrainingDate,
    }));
  };

  const prepareTraineesDetails = () => {
    let traineeDetails = prepareTraineeDetails();
    return traineeDetails.map((item) => ({
      oracleId: item.oracleId,
      firstName: item.firstName,
      lastName: item.lastName,
      cppClientCode: item.cppClientCode,
      cppProgramCode: item.cppProgramCode,
      cppProjectCode: item.cppProjectCode,
      jobTitle: item.jobTitle,
      projectName: item.projectName,
      department: item.department,
      locationId: item.locationId,
      tdt: item.tdt,
      productTrainingStartDate: item.productTrainingStartDate,
    }));
  };

  const doesClientNameInclude = (name) =>
    selectedNewClientProgram.clientName
      ?.toLowerCase()
      .includes(name.toLowerCase());

  const saveAttachment = async (payload) => {
    setUploadOnboardingTemplateShowHeader(true);
    setUploadOnboardingTemplateLoading(true);
    const response = await SaveAttachmentRitm(payload);
    setUploadOnboardingTemplateLoading(false);
    let isClientSpecific = false;

    if (
      doesClientNameInclude("century") ||
      doesClientNameInclude("kaiser") ||
      doesClientNameInclude("booking")
    ) {
      isClientSpecific = true;
      let clientTrainees = selectedRows.activeTrainee.map((item) => {
        return {
          oracleId: item.oracleId,
          firstName: item.preferredFirstName,
          lastName: item.preferredLastName,
          requestType: selectedTypeOfRequest,
        };
      });
      let AttachForClientPayload = {
        Table_sys_id: payload?.Table_sys_id,
        Trainees: clientTrainees,
      };

      const clientResponse = await SaveAttachmentRitmForClient(
        AttachForClientPayload,
      );
      if (response.status === true && clientResponse.status === true) {
        setUploadOnboardingTemplateSuccess(true);
      } else {
        setUploadOnboardingTemplateSuccess(false);
      }
    }

    if (doesClientNameInclude("capital one")) {
      isClientSpecific = true;
      let clientTrainees = selectedRows.map((item) => {
        return {
          oracleId: item.oracleId,
          firstName: item.preferredFirstName,
          middleName: "",
          lastName: item.preferredLastName,
        };
      });
      let AttachForClientPayload = {
        Table_sys_id: payload?.Table_sys_id,
        Trainees: clientTrainees,
      };

      const clientResponse = await SaveAttachmentRitmForCapClient(
        AttachForClientPayload,
      );

      if (response.status === true && clientResponse.status === true) {
        setUploadOnboardingTemplateSuccess(true);
      } else {
        setUploadOnboardingTemplateSuccess(false);
      }
    }

    if (response.status === true && !isClientSpecific) {
      setUploadOnboardingTemplateSuccess(true);
    } else {
      setUploadOnboardingTemplateSuccess(false);
    }
  };

  const saveAttachmentToFacilities = async (payload) => {
    setUploadFacilitiesShowHeader(true);
    setUploadFacilitiesTemplateLoading(true);
    const response = await SaveAttachmentFacilities(payload);
    setUploadFacilitiesTemplateLoading(false);
    if (response.status === true) {
      setUploadFacilitiesTemplateSuccess(true);
    } else {
      setUploadFacilitiesTemplateSuccess(false);
    }
  };

  const insertTicket = async (idmTicketNumber) => {
    let trainees = selectedRows.map((item) => {
      return {
        classTraineeId: item.classTraineeId,
      };
    });

    let payload = {
      classRosterId: classRosterId,
      idmTicketNumber: idmTicketNumber,
      ticketType:
        selectedTypeOfRequest === "Activation (New Hire or Reactivation)"
          ? "Activation"
          : selectedTypeOfRequest,
      newClientProgram: selectedNewClientProgram.ProjectCode,
      createdBy: localStorage.getItem("User"),
      classTrainees: trainees,
    };

    await insertIdmTicket(idmTicketNumber, payload, classRosterId, false);
  };

  // Helper function to silently save facilities ticket details to database
  const saveFacilitiesTicketDetailsToDb = async (
    facilitiesTicketNumber,
    classRosterId,
    selectedTypeOfRequest,
    selectedNewClientProgram,
    selectedRows,
  ) => {
    try {
      // Prepare trainees array matching ClassTraineeRequest structure
      const trainees = selectedRows.map((trainee) => ({
        classTraineeId: trainee.classTraineeId,
      }));

      const payload = {
        classRosterId: classRosterId,
        facilitiesTicketNumber: facilitiesTicketNumber,
        ticketType:
          selectedTypeOfRequest === "Activation (New Hire or Reactivation)"
            ? "Activation"
            : selectedTypeOfRequest,
        newClientProgramCode: selectedNewClientProgram.ProjectCode || "",
        createdBy: localStorage.getItem("User") || "System",
        classTrainees: trainees,
      };

      const response = await insertFacilityTicket(payload, false);

      if (
        response &&
        (response.status !== true || response.statusCode !== 200)
      ) {
        showSnack(
          `Facilities ticket created in ServiceNow but failed to save to database for roster ${classRosterId}. Please contact support.`,
          "warning",
        );
      }
    } catch (error) {
      showSnack(
        `An error occurred while saving the Facilities ticket to the database for roster ${classRosterId}. Please contact support.`,
        "error",
      );
    }
  };

  const insertComment = async (RITMRequest) => {
    const ritmNumber = RITMRequest.data["result"].number;
    let reportPII = `${window.location.origin}/contact-roster/${classRosterId}' target="_blank"`;
    let ritmSysId = RITMRequest.data["result"].sysid;
    let reportName = `${window.location.origin}/OBT/${ritmNumber}' target="_blank"`;
    const shippingReport = `${window.location.origin}/shipping/${ritmNumber}' target="_blank"`;
    let workNote = `[code]<a href='${reportName}>${window.location.origin}/OBT/${ritmNumber}
            </a> </br> </br>  <a href='${reportPII}>${window.location.origin}/contact-roster/${classRosterId}</a>
             </br> </br>
          <a href='${shippingReport}>${window.location.origin}/shipping/${ritmNumber}</a>
            [/code]`;

    let payloadComment = {
      work_Notes: workNote,
    };

    await SaveRitmComment(ritmSysId, payloadComment);
  };

  const prepareInsertPayload = (oracleIds, idmTicketNumber) => ({
    classRosterId: classRosterId,
    waveTrainerOracleId: waveTrainerDetails.OracleId,
    managerOracleId: managerDetails.OracleId,
    requestForOracleId: requestForDetails.OracleId,
    siteLocationName: selectedSite.LocationName,
    newClientProgramName: selectedNewClientProgram.ProjectName,
    ticketNumber: idmTicketNumber,
    statusId: 0,
    Trainees: oracleIds.join(","),
    createdBy: localStorage.getItem("OracleId"),
  });

  // Helper function to handle RITM ticket response
  const handleRitmTicketResponse = async (
    getIdmRitmDetailResponse,
    setGetRitmTicketSuccess,
    setRitmNumber,
    prepareTraineeDetails,
    saveAttachment,
    insertTicket,
    insertComment,
  ) => {
    setGetRitmTicketSuccess(true);
    setRitmNumber(getIdmRitmDetailResponse.data["result"].number);

    const ritmSysId = getIdmRitmDetailResponse.data["result"].sysid;
    const traineeDetails = prepareTraineeDetails();

    const traineesPayload = {
      Table_sys_id: ritmSysId,
      Trainees: traineeDetails,
    };

    saveAttachment(traineesPayload);
    insertTicket(getIdmRitmDetailResponse.data["result"].number);
    await insertComment(getIdmRitmDetailResponse);

    return {
      traineesPayload,
      ritmNumber: getIdmRitmDetailResponse.data["result"].number,
    };
  };

  // Helper function to handle facilities ticket
  const handleFacilitiesTicket = async (
    requestForDetails,
    selectedSite,
    setFacilitiesTicketShowHeader,
    setFacilitiesTicketLoading,
    setFacilitiesTicketSuccess,
    setFacilitiesTicketNumber,
    prepareTraineesDetails,
    saveAttachmentToFacilities,
  ) => {
    const description = "Please review attached roster!!";

    setFacilitiesTicketShowHeader(true);
    setFacilitiesTicketLoading(true);

    // Scenario— OracleId missing before ServiceNow call
    if (!requestForDetails?.OracleId) {
      setFacilitiesTicketLoading(false);
      setFacilitiesTicketSuccess(false);
      showSnack(
        `Facilities ticket creation failed for roster ${classRosterId} — Agent OracleId is missing. Please ensure the agent record is complete.`,
        "error",
      );
      return;
    }

    try {
      const facilitiesResponse = await insertFacilitiesTicket(
        requestForDetails.OracleId,
        selectedSite.LocationName,
        selectedSite.SysId,
        description,
      );

      setFacilitiesTicketLoading(false);

      if (facilitiesResponse.status === true) {
        setFacilitiesTicketSuccess(true);

        const facilitiesTicketResponseData = JSON.parse(
          facilitiesResponse["data"],
        );

        const facilitiesNumber = facilitiesTicketResponseData["result"].number;
        setFacilitiesTicketNumber(facilitiesNumber);

        const traineeDetails = prepareTraineesDetails();
        const facilitiesSysId = facilitiesTicketResponseData["result"].sys_id;
        const facilitiesPayload = {
          Table_sys_id: facilitiesSysId,
          TraineesData: traineeDetails,
        };

        // Scenario— Attachment upload (awaited so failures are caught)
        try {
          await saveAttachmentToFacilities(facilitiesPayload);
        } catch (attachError) {
          showSnack(
            `Facilities ticket ${facilitiesNumber} created but roster attachment upload failed for roster ${classRosterId}. Please attach manually.`,
            "warning",
          );
        }

        await saveFacilitiesTicketDetailsToDb(
          facilitiesNumber,
          classRosterId,
          selectedTypeOfRequest,
          selectedNewClientProgram,
          selectedRows,
        );
      } else {
        // Scenario — ServiceNow returned status false (SysId not found or non-2xx HTTP)
        setFacilitiesTicketSuccess(false);
        showSnack(
          facilitiesResponse?.message ||
            `Facilities ticket creation failed for roster ${classRosterId}. Please try again or raise the ticket manually via AskNow.`,
          "error",
        );
      }
    } catch (error) {
      // Scenario — Network/timeout/SSL exception calling ServiceNow
      setFacilitiesTicketLoading(false);
      setFacilitiesTicketSuccess(false);
      showSnack(
        `Facilities ticket creation encountered an unexpected error for roster ${classRosterId}. Please try again or raise the ticket manually via AskNow.`,
        "error",
      );
    }
  };

  // Helper function to handle email notification
  const handleEmailNotification = async (
    payload,
    setEmailNotificationShowHeader,
    setEmailNotificationLoading,
    setEmailNotificationSuccess,
  ) => {
    setEmailNotificationShowHeader(true);
    setEmailNotificationLoading(true);

    const emailQueueResponse = await insertIdmEmailQueue(payload);

    setEmailNotificationLoading(false);

    if (emailQueueResponse.status === true) {
      setEmailNotificationSuccess(true);
    } else {
      setEmailNotificationSuccess(false);
    }
  };

  // Helper function to handle IDM credential tracking
  const handleIdmCredentialTracking = async (
    ritmNumber,
    prepareIdmInsertPayload,
    setCreateIdmRecordShowHeader,
    setCreateIdmRecordLoading,
    setCreateIdmRecordSuccess,
    setIdmCredentialTrackingId,
  ) => {
    setCreateIdmRecordShowHeader(true);
    setCreateIdmRecordLoading(true);

    const payloadIdmInsert = prepareIdmInsertPayload(ritmNumber);
    const response = await insertIdmCredential(payloadIdmInsert, false);

    setCreateIdmRecordLoading(false);

    if (response.message === "Success") {
      setIdmCredentialTrackingId(response?.data[0]?.IDMCredentialTrackingId);
      setCreateIdmRecordSuccess(true);
    } else {
      setCreateIdmRecordSuccess(false);
    }
  };

  // Helper function to process TTF-related actions
  const processTTFActions = async (
    ttfTrainerData,
    selectedTypeOfRequest,
    traineesPayload,
    prepareInsertPayload,
    requestForDetails,
    selectedSite,
    setFacilitiesTicketShowHeader,
    setFacilitiesTicketLoading,
    setFacilitiesTicketSuccess,
    setFacilitiesTicketNumber,
    prepareTraineesDetails,
    saveAttachmentToFacilities,
    setEmailNotificationShowHeader,
    setEmailNotificationLoading,
    setEmailNotificationSuccess,
  ) => {
    if (!ttfTrainerData[8]) {
      showSnack(
        `Facilities ticket skipped for roster ${classRosterId} — Tech Equipment Solution is not set to the required value.`,
        "info",
      );
      return;
    }

    await handleFacilitiesTicket(
      requestForDetails,
      selectedSite,
      setFacilitiesTicketShowHeader,
      setFacilitiesTicketLoading,
      setFacilitiesTicketSuccess,
      setFacilitiesTicketNumber,
      prepareTraineesDetails,
      saveAttachmentToFacilities,
      classRosterId,
      selectedTypeOfRequest,
      selectedNewClientProgram,
      selectedRows,
    );

    if (selectedTypeOfRequest === "Activation (New Hire or Reactivation)") {
      const oracleIds = traineesPayload.Trainees.map(
        (trainee) => trainee.oracleId,
      );
      const payload = prepareInsertPayload(
        oracleIds,
        traineesPayload.ritmNumber,
      );

      await handleEmailNotification(
        payload,
        setEmailNotificationShowHeader,
        setEmailNotificationLoading,
        setEmailNotificationSuccess,
      );
    }
  };

  // Refactored main function
  const RITMPostCreationProcess = async (ticketSysId) => {
    setGetRitmTicketShowHeader(true);
    setGetRitmTicketLoading(true);

    const getIdmRitmDetailResponse = await getIdmRitmDetail(ticketSysId);

    setGetRitmTicketLoading(false);

    if (getIdmRitmDetailResponse.status !== true) {
      setGetRitmTicketSuccess(false);
      showSnack("Failed to get RITM details", "error");
      return;
    }

    const { traineesPayload, ritmNumber } = await handleRitmTicketResponse(
      getIdmRitmDetailResponse,
      setGetRitmTicketSuccess,
      setRitmNumber,
      prepareTraineeDetails,
      saveAttachment,
      insertTicket,
      insertComment,
    );

    await processTTFActions(
      ttfTrainerData,
      selectedTypeOfRequest,
      { ...traineesPayload, ritmNumber },
      prepareInsertPayload,
      requestForDetails,
      selectedSite,
      setFacilitiesTicketShowHeader,
      setFacilitiesTicketLoading,
      setFacilitiesTicketSuccess,
      setFacilitiesTicketNumber,
      prepareTraineesDetails,
      saveAttachmentToFacilities,
      setEmailNotificationShowHeader,
      setEmailNotificationLoading,
      setEmailNotificationSuccess,
      classRosterId,
      selectedNewClientProgram,
      selectedRows,
    );

    await handleIdmCredentialTracking(
      ritmNumber,
      prepareIdmInsertPayload,
      setCreateIdmRecordShowHeader,
      setCreateIdmRecordLoading,
      setCreateIdmRecordSuccess,
      setIdmCredentialTrackingId,
    );
  };

  const isRowSelectable = (event) => {
    if (event.data.idmTicketNumber !== "") return false;

    // ASTT-7267: when AD info is incomplete (null extensionAttribute9), let the
    // requester pick either ticket type manually instead of forcing Change Role.
    if (isAdInfoIncomplete(event.data)) return true;

    return selectedTypeOfRequest !== "Activation (New Hire or Reactivation)"
      ? event.data.activeInAD === true && event.data.isReactivation === false
      : event.data.activeInAD !== true ||
          (event.data.activeInAD === true && event.data.isReactivation === true);
  };

  const handleLoader = () => {
    if (loading === false && areAllOnLoadCallsCompleted()) {
      return null;
    } else {
      return <BackdropComponent />;
    }
  };

  return (
    <Paper
      sx={{
        flexDirection: "column",
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.35)",
        padding: 2,
        overflow: "auto",
        height: "calc(100vh - 80px)",
        margin: 1,
      }}
    >
      {handleLoader()}
      <Grid container rowGap={0.5}>
        <Grid item xs={2.4}>
          <Grid container>
            <Grid item xs={6}>
              <TextLabel text={"Roster"} fontSize={12} />
            </Grid>
            <Grid item xs={6}>
              <TextLabel text={`${t("Wave Number")}`} fontSize={12} />
            </Grid>
            <Grid item xs={6}>
              <TextLabel
                header
                text={classRosterId}
                fontSize={14}
                description={true}
              />
            </Grid>
            <Grid item xs={6}>
              <TextLabel text={waveNumber} fontSize={14} description={true} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2.4}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={t("TCI/TTD Start Date")} fontSize={12} />
            </Grid>
            <Grid item xs={12}>
              <TextLabel
                text={formatDateForReadOnly(tciTtdStartDate)}
                fontSize={14}
                description={true}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2.4}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={t("Production Training Start")} fontSize={12} />
            </Grid>
            <Grid item xs={12}>
              <TextLabel
                text={formatDateForReadOnly(productionTrainingStart)}
                fontSize={14}
                description={true}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2.4}>
          <Grid container>
            <Grid item xs={12}>
              <TextLabel text={t("Production Date")} fontSize={12} />
            </Grid>
            <Grid item xs={12}>
              <TextLabel
                text={formatDateForReadOnly(productionDate)}
                fontSize={14}
                description={true}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text="TTE Training Date" fontSize={12} />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <TextLabel
                text={formatDateForReadOnly(tteTrainingDate)}
                fontSize={14}
                description={true}
              />
              {/* <LocalizationProvider dateAdapter={AdapterMoment}>
                <TextField
                  variant="outlined"
                  placeholder="TTE Training Date"
                  type="date"
                  size="small"
                  error={stateErrorFlags.tteTrainingDate}
                  value={moment(
                    tteTrainingDate
                      ? new Date(tteTrainingDate)
                      : new Date("yyyy-MM-ddTHH:mm")
                  ).format("YYYY-MM-DD")}
                  fullWidth
                  onChange={(event) => handleTteTrainingDateDateChange(event)}
                  onKeyDown={(event) =>
                    handleTteTrainingDateDateChange(
                      event.key === "Backspace" ? "" : event
                    )
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </LocalizationProvider> */}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text={`${t("Taleo Req ID")}`} required fontSize={12} />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <Autocomplete
                disablePortal
                size="small"
                disableClearable
                options={taleoReqIdOptions}
                value={selectedTaleoId}
                onChange={handleTaleoReqIdChange}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  const isExisting = options.some(
                    (option) => inputValue === option.title,
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      title: `${t("ADD")} ${inputValue}`,
                    });
                  }

                  return filtered;
                }}
                getOptionLabel={(option) => {
                  if (option.value) {
                    return option.value.title;
                  }
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  return option.title;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.title}</li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    error={stateErrorFlags.taleoId}
                    placeholder={"Select / Add Taleo Req ID"}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text="Type of Request" fontSize={12} />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <Autocomplete
                disablePortal
                size="small"
                disableClearable
                options={typesOfRequests}
                value={selectedTypeOfRequest}
                defaultValue={typesOfRequests[0]}
                onChange={(event, value) => {
                  setSelectedTypeOfRequest(value);
                  setSelectedRows([]);
                  setTableFirst(0); 

                  if (value === "Change Role") {
                    // Clear date/time so user must fill it in manually
                    setRequestForDateTime(null);
                    setRequestForDateTimeForPayload(null);
                  } else {
                    // Default back to current date/time for Activation
                    const now = getCurrentDateTime();
                    setRequestForDateTime(now);
                    setRequestForDateTimeForPayload(
                      prepareRequestedForDateTimePayloadObject(now),
                    );
                  }

                  // Clear the datetime error flag on type change
                  toggleErrorFlags("requestForDateTime", false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={"Select Type of Request"}
                  />
                )}
              ></Autocomplete>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text="Request for Date/Time" fontSize={12} required />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <TextField
                  variant="outlined"
                  placeholder="Request for Date/Time"
                  type="datetime-local"
                  size="small"
                  value={requestForDateTime || ""}
                  error={stateErrorFlags.requestForDateTime}
                  fullWidth
                  onChange={(event) => handleRequestedForDateTime(event)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Grid>
        {selectedTypeOfRequest === "Change Role" && (
          <Grid item xs={2.4}>
            <Grid container rowGap={0.2}>
              <Grid item xs={12}>
                <TextLabel
                  text={`${t("Req. For TimeZone")}`}
                  fontSize={12}
                  required
                />
              </Grid>
              <Grid item xs={12} sx={paddingRight}>
                <Autocomplete
                  disablePortal
                  size="small"
                  disableClearable
                  options={timeZones}
                  value={selectedRequestedForTimezone}
                  onChange={(event, value) => {
                    setSelectedRequestedForTimezone(value);
                    toggleErrorFlags("requestedForTimezone", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={stateErrorFlags.requestedForTimezone}
                      placeholder={`Select ${t("Req. For TimeZone")}`}
                    />
                  )}
                ></Autocomplete>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text="Tech. Deployment Type" fontSize={12} required />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <Autocomplete
                disablePortal
                size="small"
                disableClearable
                options={techDeptTypeOptions}
                value={selectedTechDeploymentType}
                getOptionLabel={(option) => option.AskNowTDT}
                onChange={(event, value) => {
                  setSelectedTechDeploymentType(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={"Tech. Deployment Type :"}
                  />
                )}
              ></Autocomplete>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel
                text={`${t("New Client/Program")}`}
                fontSize={12}
                required
              />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <Autocomplete
                disablePortal
                size="small"
                disableClearable
                options={newClientProgramOptions}
                value={selectedNewClientProgram}
                getOptionLabel={(option) => option.ProjectName}
                onChange={(event, value) => {
                  setSelectedNewClientProgram(value);
                  toggleErrorFlags("newClientProgram", false);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={stateErrorFlags.newClientProgram}
                    placeholder={`Select ${t("New Client/Program")}`}
                  />
                )}
              ></Autocomplete>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text="Wave Trainer" fontSize={12} required />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <EmployeeSearch
                placeholder="Select Wave Trainer"
                onReset={() => {
                  setWaveTrainerDetails(employeeSearchResultinitialState);
                }}
                onChange={(value) => {
                  setWaveTrainerDetails(value);
                  fetchIDMuserDetails(value?.OracleId, "waveTrainer");
                }}
                disabled={false}
                isError={stateErrorFlags.waveTrainer}
                defaultEmployeeName={waveTrainerDetails?.Name || ""}
                clearFields={clearFieldsCount}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text="Requested for" fontSize={12} required />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <EmployeeSearch
                placeholder="Select Employee"
                onReset={() => {
                  setRequestForDetails(employeeSearchResultinitialState);
                }}
                onChange={(value) => {
                  setRequestForDetails(value);
                  fetchIDMuserDetails(value?.OracleId, "requestedFor");
                }}
                isError={stateErrorFlags.requestedFor}
                disabled={false}
                clearFields={clearFieldsCount}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text="Site/Location" fontSize={12} required />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <Autocomplete
                disablePortal
                size="small"
                disableClearable
                options={siteOptions}
                value={selectedSite}
                onChange={(event, value) => {
                  setSelectedSite(value);
                  toggleErrorFlags("site", false);
                }}
                getOptionLabel={(option) => option.LocationName}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={stateErrorFlags.site}
                    placeholder={"Select Site/Location"}
                  />
                )}
              ></Autocomplete>
            </Grid>
          </Grid>
        </Grid>
        {selectedTypeOfRequest === "Change Role" && (
          <Grid item xs={2.4}>
            <Grid container rowGap={0.2}>
              <Grid item xs={12}>
                <TextLabel
                  text={t("Current Client/Program")}
                  fontSize={12}
                  required
                />
              </Grid>
              <Grid item xs={12} sx={paddingRight}>
                <Autocomplete
                  disablePortal
                  size="small"
                  disableClearable
                  multiple
                  options={currentClientProgramOptions}
                  onChange={(event, value) => {
                    if (value?.length) {
                      setSelectedCurrentClientProgram(value);
                      toggleErrorFlags("currentClientProgram", false);
                    } else {
                      dispatch(
                        setSelectedCurrentClientProgram([
                          initialCurrentClientProgramOptionState,
                        ]),
                      );
                      toggleErrorFlags("currentClientProgram", true);
                    }
                  }}
                  getOptionLabel={(option) =>
                    `${option.name} ${option.u_client_code}`
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={stateErrorFlags.currentClientProgram}
                      placeholder={`Select ${t("Current Client/Program")}`}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        title={option.name}
                        variant="filled"
                        label={option.name}
                        {...getTagProps({ index })}
                        size="medium"
                        sx={{ borderRadius: 4 }}
                      />
                    ))
                  }
                  renderOption={(props, option, state) => (
                    <li {...props} key={option.sysid}>
                      {`${option.name}.${option.u_client_code}`}
                      &nbsp;
                      {state.selected && (
                        <Check fontSize="small" sx={{ color: blue[400] }} />
                      )}
                    </li>
                  )}
                ></Autocomplete>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid item xs={2.4}>
          <Grid container rowGap={0.2}>
            <Grid item xs={12}>
              <TextLabel text="Manager" fontSize={12} required />
            </Grid>
            <Grid item xs={12} sx={paddingRight}>
              <EmployeeSearch
                placeholder="Select Manager"
                onReset={() => {
                  setManagerDetails(employeeSearchResultinitialState);
                }}
                onChange={(value) => {
                  setManagerDetails(value);
                  fetchIDMuserDetails(value?.OracleId, "manager");
                }}
                disabled={false}
                clearFields={clearFieldsCount}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4} sx={{ pt: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "#3299FF",

                  "&.Mui-disabled": {
                    color: blue[200],
                  },
                  "& .MuiSvgIcon-root": { fontSize: 28 },
                }}
                checked={isNoEquipmentNeeded}
                onChange={(event) => {
                  setisNoEquipmentNeeded(event.target.checked);
                }}
              />
            }
            sx={{
              "& .MuiFormControlLabel-label": {
                fontWeight: "bold",
                fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                pl: 1,
                color: "#3F5765",
                letterSpacing: "0.10em",
              },
              "&.Mui-disabled": {
                color: "#3F5765",
                "-webkit-text-fill-color": "#3F5765",
              },
            }}
            label="If Selected, equipment will not be provisioned or shipped."
            labelPlacement="end"
          />
        </Grid>
        <Grid
          item
          xs={selectedTypeOfRequest === "Change Role" ? 3.2 : 5.6}
        ></Grid>
        <Grid item xs={1.6} sx={{ pt: 1 }}>
          <CustomButton
            variant="contained"
            sx={{ backgroundColor: "#3299FF" }}
            onClick={handleGenerateIdmTicket}
          >
            Generate IDM Ticket
          </CustomButton>
        </Grid>
        <Grid item xs={0.8} sx={{ pt: 1 }}>
          <CustomButton
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{ color: "#3299FF" }}
          >
            Back
          </CustomButton>
        </Grid>
        <Grid item xs={12}></Grid>

        {selectedRows?.filter(isAdInfoIncomplete).length > 0 && (
          <Grid item xs={12} sx={{ pb: 1 }}>
            <Alert severity="warning">
              <AlertTitle>Active Directory information is incomplete</AlertTitle>
              Active Directory information is incomplete for Selected Users.
              Please review and choose New Hire or Change Role as needed.
            </Alert>
          </Grid>
        )}

        <Grid item xs={12}>
          <PrimeReactDataGrid
            key={selectedTypeOfRequest}
            dataKey="oracleId"
            size="small"
            customtitle={"Trainee details"}
            value={traineeDetailRows}
            columns={columns}
            filterprops={filterProps}
            removableSort
            resizableColumns
            showGridlines
            paginator
            first={tableFirst}
            rows={tableRows}
            onPage={(e) => {
              setTableFirst(e.first);
              setTableRows(e.rows);
            }}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate={
              "{first} to {last} of {totalRecords} Trainees"
            }
            columnResizeMode="expand"
            selectionMode="multiple"
            dragSelection
            isDataSelectable={isRowSelectable}
            onSelectionChange={onRowSelectChange}
            selection={selectedRows}
            metaKeySelection={false}
            enableGlobalFilter={true}
            enableStickyHeader={true}
            enableScrollable={true}
            scrollHeight="calc(100vh - 440px)"
            globalFilterFields={[
              "oracleId",
              "preferredFirstName",
              "preferredLastName",
              "dateAdded",
              "activeInAD",
              "idmTicketNumber",
              "cppClientCode",
              "cppProgramCode",
            ]}
            sortMode="multiple"
            emptyMessage={"No Trainees found."}
          ></PrimeReactDataGrid>
        </Grid>
      </Grid>
      <Dialog
        open={idmResponseDialogOpen}
        onClose={() => setIdmResponseDialogOpen(false)}
        maxWidth="lg"
      >
        <DialogTitle>
          <TextLabel
            text={"Generate IDM Ticket"}
            header
            fontSize={16}
          ></TextLabel>
        </DialogTitle>
        <DialogContent>
          <Grid container sx={{ width: 900 }}>
            <Grid item xs={12}>
              {createTicketShowHeader && (
                <Grid container>
                  <Grid item xs={0.5}>
                    {createTicketLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      createTicketSuccess && <Check sx={CheckStyle} />
                    )}
                  </Grid>
                  <Grid item xs={11.5} sx={{ pt: 0.5 }}>
                    {createTicketShowHeader ? (
                      <TextLabel
                        text={"Create IDM Request"}
                        fontSize={14}
                      ></TextLabel>
                    ) : null}
                  </Grid>
                  <Grid item xs={0.5} sx={{ pr: 3, pb: 1 }}>
                    <Divider
                      orientation="vertical"
                      sx={{ borderRightWidth: 2, borderColor: blue[100] }}
                    />
                  </Grid>
                  <Grid item xs={11.5}>
                    {createTicketSuccess ? (
                      <TextLabel
                        text={`${reqNumber} created successfully.`}
                        fontSize={14}
                        description={true}
                      ></TextLabel>
                    ) : (
                      !createTicketLoading && (
                        <TextLabel
                          text={"Failed to Create IDM Ticket."}
                          fontSize={14}
                          description={true}
                        ></TextLabel>
                      )
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              {getRitmTicketShowHeader && (
                <Grid container>
                  <Grid item xs={0.5}>
                    {getRitmTicketLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      getRitmTicketSuccess && <Check sx={CheckStyle} />
                    )}
                  </Grid>
                  <Grid item xs={11.5} sx={{ pt: 0.5 }}>
                    {getRitmTicketShowHeader ? (
                      <TextLabel
                        text={"Retreive RITM Ticket Details"}
                        fontSize={14}
                      ></TextLabel>
                    ) : null}
                  </Grid>
                  <Grid item xs={0.5} sx={{ pr: 3, pb: 1 }}>
                    {uploadOnboardingTemplateShowHeader && (
                      <Divider
                        orientation="vertical"
                        sx={{ borderRightWidth: 2, borderColor: blue[100] }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={11.5}>
                    {getRitmTicketSuccess ? (
                      <TextLabel
                        text={`${ritmNumber} retrieved Successfully.`}
                        fontSize={14}
                        description={true}
                      ></TextLabel>
                    ) : (
                      !getRitmTicketLoading && (
                        <TextLabel
                          text={"Failed to Retrieve RITM Ticket."}
                          fontSize={14}
                          description={true}
                        ></TextLabel>
                      )
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              {uploadOnboardingTemplateShowHeader && (
                <Grid container>
                  <Grid item xs={0.5}>
                    {uploadOnboardingTemplateLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      uploadOnboardingTemplateSuccess && (
                        <Check sx={CheckStyle} />
                      )
                    )}
                  </Grid>
                  <Grid item xs={11.5} sx={{ pt: 0.5 }}>
                    {uploadOnboardingTemplateShowHeader ? (
                      <TextLabel
                        text={"Upload onboarding template to RITM Ticket"}
                        fontSize={14}
                      ></TextLabel>
                    ) : null}
                  </Grid>
                  <Grid item xs={0.5} sx={{ pr: 3, pb: 1 }}>
                    {facilitiesTicketShowHeader && (
                      <Divider
                        orientation="vertical"
                        sx={{ borderRightWidth: 2, borderColor: blue[100] }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={11.5}>
                    {uploadOnboardingTemplateSuccess ? (
                      <TextLabel
                        text={"Onboarding Template uploaded Successfully."}
                        fontSize={14}
                        description={true}
                      ></TextLabel>
                    ) : (
                      !uploadOnboardingTemplateLoading && (
                        <TextLabel
                          text={"Failed to Upload Onboarding Template."}
                          fontSize={14}
                          description={true}
                        ></TextLabel>
                      )
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              {facilitiesTicketShowHeader && (
                <Grid container>
                  <Grid item xs={0.5}>
                    {facilitiesTicketLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      facilitiesTicketSuccess && <Check sx={CheckStyle} />
                    )}
                  </Grid>
                  <Grid item xs={11.5} sx={{ pt: 0.5 }}>
                    {facilitiesTicketShowHeader ? (
                      <TextLabel
                        text={"Create facilities ticket to RITM Ticket"}
                        fontSize={14}
                      ></TextLabel>
                    ) : null}
                  </Grid>
                  <Grid item xs={0.5} sx={{ pr: 3, pb: 1 }}>
                    {uploadFacilitiesTemplateShowHeader && (
                      <Divider
                        orientation="vertical"
                        sx={{ borderRightWidth: 2, borderColor: blue[100] }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={11.5}>
                    {facilitiesTicketSuccess ? (
                      <TextLabel
                        text={`${facilitiesTicketNumber} created Successfully.`}
                        fontSize={14}
                        description={true}
                      ></TextLabel>
                    ) : (
                      !facilitiesTicketLoading && (
                        <TextLabel
                          text={"Failed to create Facilities Ticket."}
                          fontSize={14}
                          description={true}
                        ></TextLabel>
                      )
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              {uploadFacilitiesTemplateShowHeader && (
                <Grid container>
                  <Grid item xs={0.5}>
                    {uploadFacilitiesTemplateLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      uploadFacilitiesTemplateSuccess && (
                        <Check sx={CheckStyle} />
                      )
                    )}
                  </Grid>
                  <Grid item xs={11.5} sx={{ pt: 0.5 }}>
                    {facilitiesTicketShowHeader ? (
                      <TextLabel
                        text={"Upload facilities template to Facilities Ticket"}
                        fontSize={14}
                      ></TextLabel>
                    ) : null}
                  </Grid>
                  <Grid item xs={0.5} sx={{ pr: 3, pb: 1 }}>
                    {emailNotificationShowHeader && (
                      <Divider
                        orientation="vertical"
                        sx={{ borderRightWidth: 2, borderColor: blue[100] }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={11.5}>
                    {uploadFacilitiesTemplateSuccess ? (
                      <TextLabel
                        text={`Facilities Template uploaded Successfully.`}
                        fontSize={14}
                        description={true}
                      ></TextLabel>
                    ) : (
                      !uploadFacilitiesTemplateLoading && (
                        <TextLabel
                          text={"Failed to upload Facilities Template."}
                          fontSize={14}
                          description={true}
                        ></TextLabel>
                      )
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              {emailNotificationShowHeader && (
                <Grid container>
                  <Grid item xs={0.5}>
                    {emailNotificationLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      emailNotificationSuccess && <Check sx={CheckStyle} />
                    )}
                  </Grid>
                  <Grid item xs={11.5}>
                    {emailNotificationShowHeader ? (
                      <TextLabel
                        text={"Send Headset email notification"}
                        fontSize={14}
                      ></TextLabel>
                    ) : null}
                  </Grid>
                  <Grid item xs={0.5}></Grid>
                  <Grid item xs={11.5}>
                    {emailNotificationSuccess ? (
                      <TextLabel
                        text={"Headset email notification Sent Successfully."}
                        fontSize={14}
                        description={true}
                      ></TextLabel>
                    ) : (
                      !emailNotificationLoading && (
                        <TextLabel
                          text={"Failed to send Headset email notification."}
                          fontSize={14}
                          description={true}
                        ></TextLabel>
                      )
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              {createIdmRecordShowHeader && (
                <Grid container>
                  <Grid item xs={0.5}>
                    {createIdmRecordLoading ? (
                      <CircularProgress size={24} />
                    ) : (
                      createIdmRecordSuccess && <Check sx={CheckStyle} />
                    )}
                  </Grid>
                  <Grid item xs={11.5} sx={{ pt: 0.5 }}>
                    {createIdmRecordShowHeader ? (
                      <TextLabel
                        text={"Create IDM Credential"}
                        fontSize={14}
                      ></TextLabel>
                    ) : null}
                  </Grid>
                  <Grid item xs={0.5} sx={{ pr: 3, pb: 1 }}>
                    <Divider
                      orientation="vertical"
                      sx={{ borderRightWidth: 2, borderColor: blue[100] }}
                    />
                  </Grid>
                  <Grid item xs={11.5}>
                    {createIdmRecordSuccess ? (
                      <TextLabel
                        text={`${idmCredentialTrackingId} Idm Credential created successfully.`}
                        fontSize={14}
                        description={true}
                      ></TextLabel>
                    ) : (
                      !createIdmRecordLoading && (
                        <TextLabel
                          text={"Failed to Create IDM Credential."}
                          fontSize={14}
                          description={true}
                        ></TextLabel>
                      )
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <CustomButton
            variant="contained"
            disabled={isIdmCreationLoadersActive()}
            onClick={() => setIdmResponseDialogOpen(false)}
            color="primary"
          >
            Close
          </CustomButton>
        </DialogActions>
      </Dialog>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </Paper>
  );
}
